import { useNavigate } from 'react-router-dom'

import { routes } from '@Config/config'

import style from './GoBack.module.scss'

export const GoBack = () => {
    const navigate = useNavigate()
    return (
        <div className={style.container}>
            <span onClick={() => navigate(routes.DOCS)}>Вернуться назад</span>
        </div>
    )
}
